import { render, staticRenderFns } from "./editor.vue?vue&type=template&id=ab08c300&scoped=true"
import script from "./editor.vue?vue&type=script&lang=js"
export * from "./editor.vue?vue&type=script&lang=js"
import style0 from "./editor.vue?vue&type=style&index=0&id=ab08c300&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab08c300",
  null
  
)

export default component.exports